import React from "react";
import PropTypes from "prop-types";
import BaseMenu from "./base-menu";
import MenuItem from "./menu-item";

function ProductTypeMenu({ genderedCategoriesData, onProductTypeClick }) {
    return (
        <BaseMenu>
            <ul>
                {genderedCategoriesData.map((productType, index) => {
                    const productTypeName = productType.name;
                    return (
                        <MenuItem
                            key={index}
                            value={productTypeName}
                            onClick={() => onProductTypeClick(productTypeName)}
                        />
                    );
                })}
            </ul>
        </BaseMenu>
    );
}

export default ProductTypeMenu;

ProductTypeMenu.propTypes = {
    genderedCategoriesData: PropTypes.array.isRequired,
    onProductTypeClick: PropTypes.func.isRequired
};
